module.exports = __webpack_public_path__ + "img/nt9-03-82-1.prt.77b00fcf.jpg";